const config = {
  apibase: process.env.REACT_APP_BASE_API_URL,
}

export default config